import { render, staticRenderFns } from "./todo_checklist.vue?vue&type=template&id=255d70b3"
import script from "./todo_checklist.vue?vue&type=script&lang=js"
export * from "./todo_checklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports